<template>
  <main class="request-status" aria-live="polite" :aria-busy="!error">
    <p>{{ error ? '資料載入失敗，請稍後再試。' : '資料載入中，請稍候…' }}</p>
    <button v-if="error" type="button" @click="$emit('retry')">重新載入</button>
  </main>
</template>

<script>
export default {
  name: 'RequestStatus',
  props: { error: Boolean },
};
</script>

<style scoped>
.request-status {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #fff7f0;
  color: #353535;
}
.request-status button {
  padding: 8px 20px;
  border: 1px solid #ff6200;
  border-radius: 8px;
  color: #a33e00;
  background: white;
}
</style>
